'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = require('./helpers');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } // import jmclient from '../../../jmclient/lib'


var AjaxFileUpload = function AjaxFileUpload() {
    var _this = this;

    _classCallCheck(this, AjaxFileUpload);

    this.upload = function (files, progressBar) {

        _this.progressBar = progressBar;
        var formData = new FormData();
        // Since this is the file only, we send it to a specific location
        var action = window.sfChat.baseApiUrl + '/api/file/upload';
        var file = files[0];
        formData.append('file', file);
        // Code common to both variants
        _this._sendXHRequest(formData, action);
    };

    this._sendXHRequest = function (formData, uri) {

        // Set up events
        _this.xhr.upload.addEventListener('loadstart', _this._onloadstartHandler, false);
        _this.xhr.upload.addEventListener('progress', _this._onprogressHandler, false);
        _this.xhr.upload.addEventListener('load', _this._onloadHandler, false);
        _this.xhr.addEventListener('readystatechange', _this._onreadystatechangeHandler, false);

        // Set up request
        _this.xhr.open('POST', uri, true);
        _this.xhr.setRequestHeader('Authorization', 'Bearer: ' + (0, _helpers.getChatConfig)().jmService.getAccessToken());
        // Fire!
        _this.xhr.send(formData);
    };

    this._onloadstartHandler = function (evt) {
        console.log('Upload started.');
    };

    this._onloadHandler = function (evt) {
        console.log('File uploaded. Waiting for response.');
    };

    this._onprogressHandler = function (evt) {
        var div = document.getElementById(_this.progressBar);
        var percent = evt.loaded / evt.total * 100;
        div.innerHTML = 'Progress: ' + percent + '%';
    };

    this._onreadystatechangeHandler = function (evt) {
        var status, text, readyState;
        try {
            readyState = evt.target.readyState;
            text = evt.target.responseText;
            status = evt.target.status;
        } catch (e) {
            console.log(e);
            return;
        }
        if (readyState === 4 && status === '200' && evt.target.responseText) {
            console.log(text);
        }
    };

    // Get an XMLHttpRequest instance
    this.xhr = new XMLHttpRequest();
    this.progressBar = '';
}

// Once the FormData instance is ready and we know
// where to send the data, the code is the same
// for both variants of this technique


// Handle the start of the transmission


// Handle the end of the transmission


// Handle the progress


// Handle the response from the server
;

exports.default = AjaxFileUpload;


// WEBPACK FOOTER //
// ../chat/lib/common/ajaxfileupload.js